import {ReportData} from "../../../reports/report.data";
import {collection, field} from "@fedeltapointofsale/data-client";
import {SellableReportSelectionData} from "../../../catalogue/sellable/controls/sellable-report-selection-control.component";

export class BasketAnalysisReportData extends ReportData<BasketAnalysisReportData> {
    @field type: string = "Basket Sales";
    @field reportType: string = "PRODUCT";
    @field limit: number = 10;
    @collection() groupBy: string[] = ["none"];
    @collection(SellableReportSelectionData) sellables: SellableReportSelectionData[];
}
